<template>
  <global-layout>
    <a-tabs
      v-if="multipage"
      :active-key="activePage"
      style="margin-top: -8px; margin-bottom: 8px"
      :hide-add="true"
      type="editable-card"
      @change="changePage"
      @edit="editPage"
    >
      <template v-for="page in pageList">
        <a-tab-pane
          :id="page.fullPath"
          :key="page.fullPath"
          v-if="!(page.meta && page.meta.hideTab)"
        >
          <span slot="tab" :pagekey="page.fullPath">{{ page.name }}</span>
        </a-tab-pane>
      </template>
    </a-tabs>
    <transition name="page-toggle">
      <keep-alive v-if="multipage" :exclude="/(role_and_app|app_detial)/">
        <router-view />
      </keep-alive>
      <router-view v-else />
    </transition>
  </global-layout>
</template>

<script>
import GlobalLayout from './GlobalLayout';

export default {
  name: 'MenuView',
  components: { GlobalLayout },
  data() {
    return {
      pageList: [],
      myPageList: [],
      linkList: [],
      oldActivePage: '',
      activePage: ''
    };
  },
  computed: {
    multipage() {
      return this.$store.state.setting.multipage;
    }
  },
  created() {
    this.pageList.push(this.createNewRoute(this.$route));
    this.linkList.push(this.$route.fullPath);
    this.activePage = this.$route.fullPath;
  },
  watch: {
    $route: function(newRoute, oldRoute) {
      newRoute = this.createNewRoute(newRoute);

      this.oldActivePage = oldRoute.fullPath;
      this.activePage = newRoute.fullPath;
      if (!this.multipage) {
        this.linkList = [newRoute.fullPath];
        this.pageList = [newRoute];
      } else {
        // 通过key判断是否是新的路由
        let index = this.pageList.findIndex(v => v.key == newRoute.key);
        // 替换 path相同的路由
        if (index >= 0) {
          // newRoute.path =
          this.linkList[index] = newRoute.fullPath;
          this.pageList[index] = newRoute;
        } else {
          this.linkList.push(newRoute.fullPath);
          this.pageList.push(newRoute);
          this.validateLeaveClose();
        }
      }
    },
    activePage: function(key) {
      this.$router.push(key);
    },
    multipage: function(newVal, oldVal) {
      if (!newVal) {
        this.linkList = [this.$route.fullPath];
        this.pageList = [this.$route];
      }
    }
  },
  methods: {
    // 处理路由params参数
    createNewRoute(route) {
      let copyRoute = Object.assign({ key: '' }, route);
      let values = Object.values(copyRoute.params),
        keyPath = copyRoute.path;

      if (values.length) {
        values.forEach(v => {
          keyPath = keyPath.replace('/' + v, '');
        });
      }

      copyRoute.key = keyPath;

      return copyRoute;
    },
    changePage(key) {
      let oldActivePage = this.activePage;
      this.oldActivePage = oldActivePage;

      this.activePage = key;
      this.validateLeaveClose();
    },
    editPage(key, action) {
      this[action](key);
    },
    // 离开时是否关闭tab
    validateLeaveClose() {
      if (!this.multipage) {
        return;
      }

      let lastPageIndex = this.pageList.findIndex(
        v => v.fullPath == this.oldActivePage
      );

      // console.log('oldActivePage-------------------', lastPageIndex);

      let meta = this.pageList[lastPageIndex].meta;
      if (meta && meta.leaveClose) {
        this.remove(this.oldActivePage);
      }
    },
    remove(key) {
      if (this.pageList.length === 1) {
        this.$message.warning('这是最后一页，不能再关闭了啦');
        return;
      }
      this.pageList = this.pageList.filter(item => item.fullPath !== key);
      let index = this.linkList.indexOf(key);
      this.linkList = this.linkList.filter(item => item !== key);
      index = index >= this.linkList.length ? this.linkList.length - 1 : index;
      this.activePage = this.linkList[index];
    },

    /**
     * 由于ant-design-vue组件库的TabPane组件暂不支持自定义监听器，无法直接获取到右键target所在标签页的 pagekey 。故增加此方法用于
     * 查询右键target所在标签页的标识 pagekey ，以用于自定义右键菜单的事件处理。
     * 注：TabPane组件支持自定义监听器后可去除该方法并重构 ‘自定义右键菜单的事件处理’
     * @param target 查询开始目标
     * @param count 查询层级深度 （查找层级最多不超过3层，超过3层深度直接返回 null）
     * @returns {String}
     */
    getPageKey(target, depth) {
      depth = depth || 0;
      if (depth > 2) {
        return null;
      }
      let pageKey = target.getAttribute('pagekey');
      pageKey =
        pageKey ||
        (target.previousElementSibling
          ? target.previousElementSibling.getAttribute('pagekey')
          : null);
      return (
        pageKey ||
        (target.firstElementChild
          ? this.getPageKey(target.firstElementChild, ++depth)
          : null)
      );
    },
    onMenuSelect(key, target) {
      let pageKey = this.getPageKey(target);
      switch (key) {
        case '1':
          this.closeLeft(pageKey);
          break;
        case '2':
          this.closeRight(pageKey);
          break;
        case '3':
          this.closeOthers(pageKey);
          break;
        default:
          break;
      }
    },
    closeOthers(pageKey) {
      let index = this.linkList.indexOf(pageKey);
      this.linkList = this.linkList.slice(index, index + 1);
      this.pageList = this.pageList.slice(index, index + 1);
      this.activePage = this.linkList[0];
    },
    closeLeft(pageKey) {
      let index = this.linkList.indexOf(pageKey);
      this.linkList = this.linkList.slice(index);
      this.pageList = this.pageList.slice(index);
      if (this.linkList.indexOf(this.activePage) < 0) {
        this.activePage = this.linkList[0];
      }
    },
    closeRight(pageKey) {
      let index = this.linkList.indexOf(pageKey);
      this.linkList = this.linkList.slice(0, index + 1);
      this.pageList = this.pageList.slice(0, index + 1);
      if (this.linkList.indexOf(this.activePage < 0)) {
        this.activePage = this.linkList[this.linkList.length - 1];
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
